var ENV = {
  LOCAL: 'local',
  DEV: 'dev',
  SIT: 'sit',
  PRE: 'pre',
  PROD: 'prod'
};
export var getEnv = function getEnv() {
  if (typeof window === 'undefined') {
    // throw new Error('wrong env')
    return ENV.PROD;
  }
  var _window$location = window.location,
    hostname = _window$location.hostname,
    pathname = _window$location.pathname;
  if (hostname.match(/^\d/) && hostname.indexOf('h5app') === -1) {
    return ENV.LOCAL;
  }
  var IPv4Reg = /((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}/;
  if (IPv4Reg.test(hostname)) {
    return ENV.LOCAL;
  }

  // https://2018080260797946.h5app.alipay.net/index.html -我的公益
  if (/^\d+\.h5app\.alipay\.net$/.test(hostname)) {
    return ENV.DEV;
  } else if (/^\d+\.test\.h5app\.alipay\.net$/.test(hostname)) {
    return ENV.SIT;
  }
  switch (hostname) {
    case 'local.alipay.net':
    case 'localhost':
      return ENV.LOCAL;
    case 'render-dev.site.alipay.net':
    case 'w.alipay.net':
    case 'renderdev.alipay.com':
    case 'page.alipay.net':
    case 'oss-local-dev.marmot-cloud.com':
    case 'oss-dev.marmot-cloud.com':
    case 'oss-local-dev-01.marmot-cloud.com':
    case 'wf-cn-default.dev.alipay.net':
    case 'zyla-default.dev.alipay.net':
    case 'wf-gbl-default.dev.alipay.net':
      return ENV.DEV;
    case 'render-test.test.alipay.net':
    case 'w.test.alipay.net':
    case 'rendertest.alipay.com':
    case 'page.test.alipay.net':
    case 'test.page.alipay.net':
    case 'oss-local-test.marmot-cloud.com':
    case 'wf-cn.test.alipay.net':
    case 'zyla.test.alipay.net':
    case 'wf-gbl.test.alipay.net':
      return ENV.SIT;
    case 'render-pre.alipay.com':
    case 'renderpre.alipay.com':
    case 'cdn-pre.marmot-cloud.com':
    case 'pre.ac.alipay.com':
    case 'portal-pre.worldfirst.com.cn':
    case 'portal-pre.zyla.com':
    case 'portal-pre.worldfirst.com':
      return ENV.PRE;
    case 'gproxy.alipay.com':
      if (/^\/page-pre\//.test(pathname)) {
        return ENV.PRE;
      } else {
        return ENV.PROD;
      }
    case 'render.ac.alipay.com': // marmot
    case 'ac.alipay.com':
    case 'cdn.marmot-cloud.com':
    case 'g.alipayplus.com':
    case 'portal.worldfirst.com.cn':
    case 'portal.zyla.com':
    case 'portal.worldfirst.com':
      return ENV.PROD;
    default:
      return ENV.PROD;
  }
};